import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bp2qh0z57y: FaireBrandEntity = {
  token: "b_bp2qh0z57y",
  type: "brand",
  name: "Nai Gifts",
  avatarUrl:
    "https://cdn.faire.com/fastly/0593f6f39020a481602dccabe0a21b621155fca44777efb5c2fa353dc9803e06.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d0a65fbfc6347f9e8547f0efd0631b341f4de0db51a27fcb28b578357e93167b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0593f6f39020a481602dccabe0a21b621155fca44777efb5c2fa353dc9803e06.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0a65fbfc6347f9e8547f0efd0631b341f4de0db51a27fcb28b578357e93167b.jpeg",
  location: "La Prairie, QC, CAN",
  minimumOrderDollars: 208,
  rating: 4.7,
  reviewCount: 67,
  isInsider: false,
  description:
    "A captivating colourful experience to delight you as soon as you enter our world.\nHeadquartered in Canada, Nai Gifts specializes in Handmade colourful Lamps, Home Decor, Women Fashion Accessories and much more. We strive to provide you with best quality products with maximum satisfaction and ever low prices. Have a great shopping!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:29.252Z",
    importedBy: "entity-db-cli",
  },
};
